module.exports = __webpack_public_path__ + "static/media/search_time.603507af.svg";